export default {
    state: {
        autoRechargeList: []
    },
    mutations: {
        setAutoRechargeList (state, data) {
            state.autoRechargeList = data
        }
    },
    actions: {
        setAutoRechargeList ({ commit }, data) {
            commit('setAutoRechargeList', data)
        }
    },
    getters: {
        getAutoRechargeList: (state) => state.autoRechargeList
    }
}
